class CustomIcons extends HTMLElement {
    constructor() {
        super();


        const swiper = new Swiper(this.querySelector('.swiper'), {
            // Optional parameters
            direction: 'horizontal',
            loop: false,
            slidesPerView: 1,
            spaceBetween: 50,

            pagination: {
                el: this.querySelector('.swiper-pagination'),
            },

            breakpoints: {
                450: {
                    slidesPerView: 1.2,
                },
                768: {
                    slidesPerView: 2,
                },
                1024: {
                    slidesPerView: 3,
                },
            },

        });

    }
}

customElements.define('custom-icons', CustomIcons);